import { render, staticRenderFns } from "./PartnershipContainer.vue?vue&type=template&id=918c6ad0&scoped=true"
import script from "./PartnershipContainer.vue?vue&type=script&lang=ts"
export * from "./PartnershipContainer.vue?vue&type=script&lang=ts"
import style0 from "./PartnershipContainer.vue?vue&type=style&index=0&id=918c6ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918c6ad0",
  null
  
)

export default component.exports